var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{class:_vm.btnClass,attrs:{"disabled":_vm.disabled,"color":"success","type":"filled","icon-pack":"feather","icon":_vm.btnIcon},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.btnText || _vm.$t('add'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }